
































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class OperationResultTips extends Vue {
  @Prop() type!: string // 提示类型, success | error | running ｜ other
  @Prop() tipsTitle!: string
  @Prop() tipsContent!: string
}
